import { render, staticRenderFns } from "./ReferenceLookupInput.vue?vue&type=template&id=540f4ea3&scoped=true"
import script from "./ReferenceLookupInput.vue?vue&type=script&lang=js"
export * from "./ReferenceLookupInput.vue?vue&type=script&lang=js"
import style0 from "./ReferenceLookupInput.vue?vue&type=style&index=0&id=540f4ea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f4ea3",
  null
  
)

export default component.exports